import { defineComponent as _defineComponent } from 'vue'
import { computed, toRefs, useStore } from "@nuxtjs/composition-api";

import { useTranslate } from "@/composables";
import { getTrendingPostsStore } from "@/store/trending-posts";


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingPostsSlidegroup',
  props: {
  displayName: {
    type: String,
    required: true,
  },
  minimumPosts: {
    type: Number,
    default: 3,
  },
},
  setup(__props) {

const props = __props;


const { displayName } = toRefs(props);
const store = useStore();
const { t } = useTranslate();

const trendingPostIds = computed(() => getTrendingPostsStore(store).feeds[displayName.value]?.ids || []);

const title = t("Trending posts");

return { __sfc: true,props, displayName, store, t, trendingPostIds, title }
}

})